var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listado-acuerdos-clientes-base-tabla',{attrs:{"data":_vm.data,"dataInicial":_vm.dataInicial,"getListaAcuerdosClientesBase":_vm.getListaAcuerdosClientesBase,"load":_vm.load}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }